import Pagination from "@material-ui/lab/Pagination";
import navOptionArrow from "../../../images/navOptionArrow.svg";
import editLogo from "../../../images/edit.svg";
import view from "../../../images/view.svg";
import add from "../../../images/add.svg";
import grayCheckboxSelected from "../../../images/grayCheckboxSelected.svg";
import grayCheckboxUnselected from "../../../images/grayCheckboxUnselected.svg";
import locationsLogo from "../../../images/locations.svg";
import {
  ActionButton,
  TableActionButton,
  SwitchComponent,
  AltButton,
  StatusButton,
} from "../Buttons/Buttons";
import {
  capitalize,
  disableCopyAndContextMenu,
  exists,
} from "../../../assets/helpers/funciones";
import {
  exportablesTypes,
  caseType,
  paymentsSelectionEnum,
  providersPaymentsTypes,
  lastServiceEnum,
  membershipCodes,
  AVFaultServiceResolvedStatus,
} from "../../../assets/helpers/options";
import moment from "moment";
import { TableLoadSpinner } from "../../common/LoadSpinner/LoadSpinner";
import factura from "../../../images/factura.svg";
import {
  serviceName,
  reasignTime,
  formatMinutes,
  calculateDuration,
  transcriptStatus,
} from "../../../assets/helpers/funciones";
import {
  transcriptRoles,
  operationsRoles,
} from "../../../assets/helpers/roles";
import { TableFilter } from "../Forms/Input/Input";
import check from "../../../images/check.svg";
import x from "../../../images/x.svg";
import "./Tables.scss";
import { useEffect, useState } from "react";
import { notify } from "../../../assets/helpers/toast";
import CopyToClipboard from "react-copy-to-clipboard";
import { smsText } from "../../../assets/helpers/smsText";
import Badge from "../Badge";
import { formatCommissionMoney } from "../../../assets/helpers/operatorCommissions";

export const Checkbox = (props) => {
  const { payments, payment, select, index, param, type } = props;

  let selectedPayment = () => {
    let selected = payments?.filter((p) => p[param]);

    if (selected[0] && payment?.providerName !== selected[0]?.providerName) {
      return true;
    } else return false;
  };

  if (selectedPayment()) {
    return null;
  }

  if (
    type === exportablesTypes.PAYMENT_AV &&
    payment?.solvedFaultStatus &&
    ![
      AVFaultServiceResolvedStatus.APPROVED,
      AVFaultServiceResolvedStatus.DENIED,
    ].includes(payment?.solvedFaultStatus)
  ) {
    return null;
  }

  if (payment[param]) {
    return (
      <img
        style={{ cursor: "pointer" }}
        src={grayCheckboxSelected}
        alt="grayCheckboxSelected"
        onClick={() => select(payment, index)}
      />
    );
  }
  if (!payment[param]) {
    return (
      <img
        style={{ cursor: "pointer" }}
        src={grayCheckboxUnselected}
        alt="grayCheckboxSelected"
        onClick={() => select(payment, index)}
      />
    );
  } else return null;
};

export const SelectAllCheckbox = (props) => {
  const { data, handleMultipleSelection, param } = props;

  let selected = false;
  let [name] = data?.data?.filter((d) => d[param] === true);
  name = name?.providerName;
  let selectedCounter = data?.data?.filter(
    (d) =>
      d[param] === true &&
      d?.providerName === name &&
      d?.providerPaymentStatus !== "Pagado"
  );
  let providerNameCounter = 0;
  for (let i = 0; i < data?.data?.length; i++) {
    if (
      data?.data[i]?.providerName === name &&
      data?.data[i]?.providerPaymentStatus !== "Pagado"
    ) {
      providerNameCounter = providerNameCounter + 1;
    }

    if (data?.data[i][param]) {
      selected = true;
    }
  }
  if (!selected) return null;

  if (selected && selectedCounter?.length === providerNameCounter) {
    return (
      <img
        style={{ cursor: "pointer" }}
        src={grayCheckboxSelected}
        alt="grayCheckboxSelected"
        onClick={() => handleMultipleSelection(false, name)}
      />
    );
  } else {
    return (
      <img
        style={{ cursor: "pointer" }}
        src={grayCheckboxUnselected}
        alt="grayCheckboxSelected"
        onClick={() => handleMultipleSelection(true, name)}
      />
    );
  }
};

export const Tables = (props) => {
  const { header, dataTable, handlePageChange, edit } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.invoiceName || d?.companyName)}</td>
                <td>{capitalize(d?.contactName)}</td>
                <td>{exists(d?.phonePrefix) + "-" + exists(d?.phoneNumber)}</td>
                <td>
                  {exists(d?.identificationType) +
                    ": " +
                    exists(d?.identification)}
                </td>
                <td>{capitalize(d?.state)}</td>
                <td>{capitalize(d?.city)}</td>
                <td>{exists(d?.isActive)}</td>
                <td>
                  <div className="table-buttons-conatiner">
                    {/* <TableActionButton src={view} /> */}
                    <TableActionButton src={editLogo} action={() => edit(d)} />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ScheduledActiveServiceTable = (props) => {
  const { header, dataTable, handlePageChange } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.userName)}</td>
                <td>
                  {d?.createdAt
                    ? moment(d?.createdAt).format("DD/MM/YYYY  LTS")
                    : ""}
                </td>
                <td>
                  {d?.scheduleDate
                    ? moment(d?.scheduleDate).format("DD/MM/YYYY  LTS")
                    : ""}
                </td>
                <td>{d?.lastServiceCode}</td>
                <td>{capitalize(d?.lastServiceProductName)}</td>
                <td>{capitalize(d?.lastServiceProviderName)}</td>
                <td>{d?.status}</td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const FleetLocationTable = (props) => {
  const { header, dataTable, handlePageChange, handleLocationModal } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{d?.name}</td>
                <td>{transcriptStatus(d?.online)}</td>
                <td>
                  {d?.time ? moment(d?.time).format("DD/MM/YYYY  LTS") : ""}
                </td>
                {/* <td>{d?.lat + "  "} {d?.lng}</td> */}
                <td>
                  <TableActionButton
                    src={locationsLogo}
                    action={() => handleLocationModal(d)}
                  />
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const DriverLocationTable = (props) => {
  const { header, dataTable, handlePageChange, handleLocationModal } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{d?.type}</td>
                <td>{capitalize(d?.contactName)}</td>
                <td>{d?.status}</td>
                <td>{exists(d?.unitAlias) + " " + exists(d?.unitPlate)}</td>
                {d?.location && d?.status === "Activo" &&
                  <td>
                    <TableActionButton
                      src={locationsLogo}
                      action={() => handleLocationModal(d)}
                    />
                  </td>
                }
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};


export const CasesTrackingTable = (props) => {
  const { header, dataTable } = props;
  const getCurrentBaseUrl = () => {
    return `https://www.seguimiento.tugruero.com`
  };

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => {
              const locTime = d?.services?.provider?.locationMobile?.time;
              const isLocOld = locTime
                ? moment(locTime).isBefore(moment().startOf("day"))
                : false;
              const createdAt = d?.createdAt;
              const isCreatedOld = createdAt
                ? moment(createdAt).isBefore(moment().startOf("day"))
                : false;

              return (
                <tr key={d?._id}>
                  <td>{d?.caseId}</td>
                  <td>{d?.services?.provider?.vehicle?.plate}</td>
                  <td>
                    {d?.services?.provider?.locationMobile?.lat ? (
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={getCurrentBaseUrl() + `/following-link/${d?._id}`}
                      >
                        Link
                      </a>
                    ) : (
                      ""
                    )}
                  </td>
                  <td style={{ fontWeight: isLocOld ? "bold" : "", color: isLocOld ? "red" : "inherit" }}>
                    {locTime
                      ? moment(locTime).format("DD/MM/YYYY  LTS")
                      : ""}
                  </td>
                  <td>{d?.status}</td>
                  <td>
                    {d?.services?.type === lastServiceEnum?.ROAD_ATTENDANT
                      ? exists(d?.services?.provider?.vehicle?.plate) +
                      " " +
                      exists(d?.services?.provider?.vehicle?.alias)
                      : ""}
                  </td>
                  <td>
                    {d?.services?.type === lastServiceEnum?.CRANE
                      ? exists(d?.services?.provider?.vehicle?.plate) +
                      " " +
                      exists(d?.services?.provider?.vehicle?.alias)
                      : ""}
                  </td>
                  <td>{capitalize(d?.services?.provider?.contactName)}</td>
                  <td style={{ color: isCreatedOld ? "red" : "inherit" }}>
                    {createdAt ? moment(createdAt).format("DD/MM/YYYY") : ""}
                  </td>
                  {/* <td>sss</td> */}
                </tr>
              );
            })}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      {/* <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div> */}
    </>
  );
};

export const AllianceTable = (props) => {
  const {
    header,
    dataTable,
    handlePageChange,
    handleAction,
    showModal,
    cancelModal,
    actionModal,
  } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{d?.enterprise?.name}</td>
                <td>{d?.firstName + " " + d?.lastName}</td>
                <td>{d?.identificationType + "-" + d?.identification}</td>
                <td>
                  {d?.status === "Activo" && <img src={check} alt="check" />}
                  {d?.status === "Bloqueado" && <img src={x} alt="x" />}
                  {d?.status}{" "}
                </td>
                <td className="table-buttons-style-conatiner">
                  <ActionButton
                    style={{ backgroundColor: "#f27730", color: "white" }}
                    action={() =>
                      handleAction({
                        name: d?.firstName + " " + d?.lastName,
                        id: d?._id,
                        status: d?.status,
                      })
                    }
                    label={d?.status === "Activo" ? "Bloquear" : "Activar"}
                  />
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const GarageGPTable = (props) => {
  const { header, dataTable, handlePageChange } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>

          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td></td>
                <td>{d?.invoiceNum}</td>
                <td>{d?.client?.clientNum}</td>
                <td>{capitalize(d?.client?.name)}</td>
                <td>{d?.date ? moment(d?.date).format("DD/MM/YYYY") : ""}</td>
                <td>XXX</td>
                <td>{d?.paymentMethod}</td>
                <td>{capitalize(d?.paymentDesc)}</td>
                <td>{(d?.total - d?.pendingAmount)?.toFixed(2)}</td>
                <td>{d?.total}</td>
                <td>{d?.totalNoTax}</td>
                <td>{d?.totalTax}</td>
                <td>{d?.pendingAmount}</td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const cashbackColumns = (service) => {
  let a = ["", "", ""];
  let hasServices = service?.paymentChanges?.length > 0;

  return (
    <>
      <td>{hasServices ? service?.paymentChanges[0]?.paid : ""}</td>
      <td>
        {hasServices && service?.paymentChanges[0]?.date
          ? moment(service?.paymentChanges[0]?.date).format("DD/MM/YYYY")
          : ""}
      </td>
      {a?.map((value, index) => (
        <>
          <td>{hasServices ? service?.paymentChanges[index]?.amount : ""}</td>
          <td>{hasServices ? service?.paymentChanges[index]?.amountBs : ""}</td>
          <td>
            {hasServices
              ? capitalize(service?.paymentChanges[index]?.methodDesc)
              : ""}
          </td>
          <td>{hasServices ? service?.paymentChanges[index]?.ref : ""}</td>
          <td>
            {hasServices && service?.paymentChanges[index]?.referenceImg && (
              <a
                target="_blank"
                href={service?.paymentChanges[index]?.referenceImg}
                rel="noreferrer"
              >
                Comprobante de vuelto
              </a>
            )}
          </td>
        </>
      ))}
    </>
  );
};

export const ExportablesDBTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    displayPayment,
    type,
    tableRef,
    role,
  } = props;

  useEffect(() => {
    if (!tableRef?.current) {
      console.error("El ref no está disponible en useEffect.");
      return;
    }

    // Aplicar la función para deshabilitar copiar y menú contextual
    const cleanup = disableCopyAndContextMenu(tableRef);

    // Limpiar eventos al desmontar
    return () => cleanup && cleanup();
  }, [tableRef]);

  const { operationsSupervisor } = operationsRoles;

  const pendingStatus = (service) => {
    if (service?.paymentStatus === "Cuenta por cobrar") {
      return service?.pendingPayment?.pending ? "Pendiente" : "Pago Realizado";
    } else {
      return null;
    }
  };

  const validateAffiliation = (data) => {
    if (data?.caseType === caseType?.AFFILIATED) {
      return "Si";
    }
    if (data?.caseType === caseType?.PARTICULAR) {
      if (data?.particularCustomer?.isAffiliated) {
        return "Si";
      } else {
        return "No";
      }
    }
  };


  return (
    <>
      <div className="table-exportable-container">
        <div className="table-exportable-content">
          <table
            ref={tableRef}
            className="table exportable-table"
            onContextMenu={(e) => e.preventDefault()}
          >
            <tr>
              {role === operationsSupervisor ? (
                <>
                  {header?.map((h, i) => {
                    return (
                      <>
                        {h?.sortable === false && (
                          <th
                            key={h?.name + i}
                            style={{ display: h?.hide ? "none" : "" }}
                          >
                            {h?.name}
                          </th>
                        )}
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  {header?.map((h, i) => {
                    return (
                      <>
                        <th
                          key={h?.name + i}
                          style={{ display: h?.hide ? "none" : "" }}
                        >
                          {h?.name}
                        </th>
                      </>
                    );
                  })}
                </>
              )}
            </tr>
            {!type &&
              data?.data.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d, i) => (
                <tr key={d?.caseId}>
                  <td>
                    {capitalize(d?.createdBy[0]?.firstName)}{" "}
                    {capitalize(d?.createdBy[0]?.lastName)}
                  </td>
                  <td>
                    {capitalize(d?.user?.firstName)}{" "}
                    {capitalize(d?.user?.lastName)}
                  </td>
                  <td>{d?.caseId}</td>
                  <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                  <td>{moment(d?.createdAt).format("LTS")}</td>
                  <td>{d?.status}</td>
                  <td>
                    {capitalize(d?.particularCustomer?.firstName) ||
                      capitalize(d?.membership?.customer?.firstName) ||
                      capitalize(d?.vehicleData?.firstName)}
                  </td>
                  <td>
                    {capitalize(d?.particularCustomer?.lastName) ||
                      capitalize(d?.membership?.customer?.lastName) ||
                      capitalize(d?.vehicleData?.lastName)}
                  </td>{" "}
                  {role !== operationsSupervisor && (
                    <>
                      {[
                        caseType?.AFFILIATED,
                        caseType?.PARTICULAR,
                        caseType?.PRIMARY_CARE,
                      ].includes(d?.caseType) && <td> {d?.phone}</td>}
                      {[caseType?.ALLY].includes(d?.caseType) && (
                        <td>
                          {" "}
                          {d?.vehicleData.phonePrefix +
                            "-" +
                            d?.vehicleData.phoneNumber}
                        </td>
                      )}
                    </>
                  )}
                  <td>
                    {exists(d?.particularCustomer?.vehiclePlate) ||
                      exists(d?.membership?.vehicle?.plate) ||
                      exists(d?.vehicleData?.plate)}
                  </td>
                  <td>
                    {capitalize(d?.particularCustomer?.vehicleBrand?.brand) ||
                      capitalize(d?.membership?.vehicle?.brand) ||
                      capitalize(d?.vehicleData?.brand)}
                  </td>{" "}
                  <td>
                    {capitalize(d?.particularCustomer?.vehicleModel?.model) ||
                      capitalize(d?.membership?.vehicle?.model) ||
                      capitalize(d?.vehicleData?.model)}
                  </td>{" "}
                  <td>
                    {exists(d?.particularCustomer?.vehicleYear) ||
                      exists(d?.membership?.vehicle?.year) ||
                      capitalize(d?.vehicleData?.year)}
                  </td>{" "}
                  <td>
                    {[membershipCodes.GOLDM].includes(d?.membership?.code)
                      ? capitalize(membershipCodes.GOLD)
                      : capitalize(d?.membership?.code) ||
                      capitalize(d?.particularCustomer?.code)}
                    {d?.papMembership && "Asistencia Primaria"}
                  </td>
                  <td>
                    {capitalize(d?.membership?.status) ||
                      capitalize(d?.particularCustomer?.status)}
                    {d?.papMembership && d?.papMembership?.status}
                  </td>
                  <td>{capitalize(d?.caseType)}</td>
                  <td>{validateAffiliation(d)}</td>
                  <td>{capitalize(d?.fault)}</td>
                  <td>
                    {capitalize(d?.businessAlly?.enterprise?.name) +
                      " " +
                      capitalize(d?.businessAlly?.firstName) +
                      " " +
                      capitalize(d?.businessAlly?.lastName)}
                  </td>
                  <td>{capitalize(d?.realFault)}</td>
                  <td>{d?.towExceptionReason ? d?.towExceptionReason : ""}</td>
                  <td>{d?.caseKm ? `${d?.caseKm} KM` : ""}</td>
                  <td>{capitalize(d?.originLocation)}</td>
                  <td>
                    {d.vehicleLocationStatus === "En sótano" ? "Si" : "No"}
                  </td>
                  <td>{capitalize(d?.originZone)}</td>
                  {/* <td>{capitalize(d?.originState)}</td> */}
                  <td>{capitalize(d?.originCity)}</td>
                  <td>{capitalize(d?.destinyLocation)}</td>
                  {/* <td>{capitalize(d?.destinyState)}</td> */}
                  <td>{capitalize(d?.destinyCity)}</td>
                  <td>{d?.thirdPartyService ? "Si" : "No"}</td>
                  <td>
                    {capitalize(d?.thirdPartyParticularCustomerName) +
                      " " +
                      capitalize(d?.thirdPartyParticularCustomerLastName)}
                  </td>
                  <td>
                    {exists(d?.thirdPartyServicePhonePrefix)}
                    {d?.thirdPartyService && "-"}
                    {exists(d?.thirdPartyServicePhoneNumber)}
                  </td>
                  <td>{d?.thirdPartyVehiclePlate?.toUpperCase()}</td>
                  <td>{capitalize(d?.thirdPartyVehicleBrand)}</td>
                  <td>{capitalize(d?.thirdPartyVehicleModel)}</td>
                  <td>
                    {" "}
                    {capitalize(
                      d?.services?.filter((d) => d?.approvedBy)[0]?.approvedBy
                    )}
                  </td>
                  <td>
                    {
                      d?.services?.filter((d) => d?.approvedBy)[0]
                        ?.priceDifference
                    }
                  </td>
                  <td>{d?.taxiServ}</td>
                  <td>{d?.taxi}</td>
                  {d?.services?.map((service, j) => {
                    return (
                      <>
                        <td style={{ display: displayPayment }}>
                          {serviceName(service?.productCode)}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {service?.status}
                        </td>
                        {j === 0 && <td>{service?.towReason}</td>}
                        <td>{service?.externalTowReason}</td>
                        <td style={{ display: displayPayment }}>
                          {service?.code}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {service?.provider?.isInternal === true && "Propia"}
                          {service?.provider?.isInternal === false && "Externa"}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {capitalize(service?.provider?.contactName)}
                        </td>{" "}
                        <td style={{ display: displayPayment }}>
                          {service?.shift}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {service?.price ? service?.price + "$" : ""}{" "}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {service?.pvp ? service?.pvp + "$" : ""}{" "}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {service?.amountExcess
                            ? service?.amountExcess + " $"
                            : ""}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {service?.amountHandling
                            ? service?.amountHandling + " $"
                            : ""}
                        </td>
                        {service?.payments?.map((payment, k) => {
                          return (
                            <td style={{ display: displayPayment }}>
                              {payment?.ivaAmount
                                ? payment?.ivaAmount + " $"
                                : ""}
                            </td>
                          )
                        })}
                        <td>{service?.authorizedBy}</td>
                        <td style={{ display: displayPayment }}>
                          {service?.paymentStatus}
                        </td>
                        <td>{pendingStatus(service)}</td>
                        <td>{service?.pendingPayment?.amount}</td>
                        <td>
                          {service?.pendingPayment?.datePaid
                            ? moment(service?.pendingPayment?.datePaid).format(
                              "DD/MM/YYYY"
                            )
                            : ""}
                        </td>
                        {service?.payments?.map((payment, k) => {
                          return (
                            <>
                              <td style={{ display: displayPayment }}>
                                {capitalize(payment?.method)}
                              </td>
                              <td style={{ display: displayPayment }}>
                                {payment?.totalAmount
                                  ? payment?.totalAmount + "$"
                                  : ""}
                              </td>
                              <td style={{ display: displayPayment }}>
                                {payment?.reference}
                              </td>
                              <td style={{ display: displayPayment }}>
                                {payment?.referenceImg && (
                                  <a
                                    target="_blank"
                                    href={payment?.referenceImg}
                                    rel="noreferrer"
                                  >
                                    Comprobante de pago
                                  </a>
                                )}
                              </td>
                            </>
                          );
                        })}
                        {service?.payments?.length > 0 &&
                          cashbackColumns(service)}
                      </>
                    );
                  })}
                  {role !== operationsSupervisor && (
                    <>
                      {d?.newStages?.map((stage, i) => {
                        return <td>{reasignTime(d, i)}</td>;
                      })}
                      <td>{formatMinutes(d?.stageTimePendingUpload)}</td>
                      <td>{formatMinutes(d?.totalTicketTimeInMin)}</td>
                    </>
                  )}
                  <td>
                    {d?.services?.map((service, j) => {
                      if (service?.avImage) {
                        return (
                          <a
                            target="_blank"
                            href={service?.avImage}
                            rel="noreferrer"
                          >
                            Imagen AV
                          </a>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {d?.services?.map((service, j) => {
                      if (service?.avImageSolved) {
                        return (
                          <a
                            target="_blank"
                            href={service?.avImageSolved}
                            rel="noreferrer"
                          >
                            Resuelto por AV
                          </a>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {d?.services?.map((service, j) => {
                      if (service?.towImages?.towAtOrigin) {
                        return (
                          <a
                            target="_blank"
                            href={service?.towImages?.towAtOrigin}
                            rel="noreferrer"
                          >
                            Gruero en origen
                          </a>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {d?.services?.map((service, j) => {
                      if (service?.towImages?.vehicleOnTow) {
                        return (
                          <a
                            target="_blank"
                            href={service?.towImages?.vehicleOnTow}
                            rel="noreferrer"
                          >
                            Vehículo en grúa
                          </a>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {d?.services?.map((service, j) => {
                      if (service?.towImages?.vehicleOnRoad) {
                        return (
                          <a
                            target="_blank"
                            href={service?.towImages?.vehicleOnRoad}
                            rel="noreferrer"
                          >
                            Vehículo en destino
                          </a>
                        );
                      }
                    })}
                  </td>
                </tr>
              ))}
          </table>
        </div>

        <PrintBDTable
          data={data}
          header={header}
          displayPayment={""}
          type={type}
          tableRef={tableRef}
        />
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ExportablesReviewTable = (props) => {
  const { header, data, handlePageChange, type, tableRef } = props;

  return (
    <>
      <div className="table-container">
        <table className="table exportable-table">
          <tr>
            {header?.map((h, i) => (
              <th key={h?.name + i} style={{ display: h?.hide ? "none" : "" }}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {!type &&
            data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => (
              <tr key={d?.caseId}>
                <td>{d?.serviceCode}</td>
                <td>
                  {d?.serviceDate
                    ? moment(d?.serviceDate)?.format("DD/MM/YYYY")
                    : ""}
                </td>
                <td>{d?.vehicle?.plate}</td>
                <td>{capitalize(d?.vehicle?.brand)}</td>
                <td>{capitalize(d?.vehicle?.model)}</td>
                <td>
                  {d?.customer?.phone?.phonePrefix +
                    "-" +
                    d?.customer?.phone?.phoneNumber}
                </td>
                <td>
                  {capitalize(d?.customer?.firstName) +
                    " " +
                    capitalize(d?.customer?.lastName)}
                </td>
                <td>{d?.checkups?.coolantLevel}</td>
                <td>{d?.checkups?.engineOilLevel}</td>
                <td>{d?.checkups?.brakeFluidLevel}</td>
                <td>{d?.checkups?.gearboxOilLevel}</td>
                <td>{d?.checkups?.powerSteeringFluidLevel}</td>
                {/*  */}
                <td>{d?.checkups?.engineOilCondition}</td>
                <td>{d?.checkups?.coolantFluidCondition}</td>
                <td>{d?.checkups?.powerSteeringFluidCondition}</td>
                <td>{d?.checkups?.brakeFluidCondition}</td>
                <td>{d?.checkups?.gearboxOilCondition}</td>
                <td>{d?.checkups?.timingBeltCondition}</td>
                <td>{d?.checkups?.uniqueBeltCondition}</td>
                <td>{d?.checkups?.alternatorBeltCondition}</td>
                <td>{d?.checkups?.airConditionerBeltCondition}</td>
                <td>{d?.checkups?.steeringPumpBeltCondition}</td>
                <td>{d?.checkups?.pulleysCondition}</td>
                <td>{d?.checkups?.tensorCondition}</td>
                <td>{d?.checkups?.upperHosesCondition}</td>
                <td>{d?.checkups?.lowerHosesCondition}</td>
                <td>{d?.checkups?.thermostatCondition}</td>
                <td>{d?.checkups?.coolantTankCondition}</td>
                {/*  */}
                <td>{d?.checkups?.valveCoverLeak}</td>
                <td>{d?.checkups?.oilPanLeak}</td>
                <td>{d?.checkups?.gearboxPanLeak}</td>
                <td>{d?.checkups?.frontcrankshaftSealLeak}</td>
                <td>{d?.checkups?.rearCrankshaftSealLeak}</td>
                <td>{d?.checkups?.camshaftSealLeak}</td>
                <td>{d?.checkups?.gearboxSealLeak}</td>
                <td>{d?.checkups?.steeringHosesLeak}</td>
                <td>{d?.checkups?.steeringPumpLeak}</td>
                <td>{d?.checkups?.transferCaseLeak}</td>
                <td>{d?.checkups?.differentialLeak}</td>
                <td>{d?.checkups?.UpperRadiatorTankLeak}</td>
                <td>{d?.checkups?.LowerRadiatorTankLeak}</td>
                {/*  */}
                <td>{d?.checkups?.fuelPumpHealth}</td>
                <td>{d?.comments}</td>
              </tr>
            ))}
        </table>

        <PrintBDTable
          data={data}
          header={header}
          displayPayment={""}
          type={type}
          tableRef={tableRef}
        />
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const PrintBDTable = (props) => {
  const { data, header, displayPayment, type, tableRef } = props;

  let newHeader = header?.filter((h) => !h?.hidePrint);

  return (
    <table
      style={{ display: "none" }}
      ref={tableRef}
      className="table exportable-table"
    >
      <tr>
        {newHeader?.map((h, i) => (
          <th key={h?.name + i} style={{ display: h?.hide ? "none" : "" }}>
            {h?.name}
            {h?.sortable && (
              <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
            )}
          </th>
        ))}
      </tr>
      {!type &&
        data?.data.length > 0 &&
        !data?.isLoading &&
        data?.data?.map((d, i) => (
          <tr key={d?.caseId}>
            <td>
              {d?.user?.firstName} {d?.user?.lastName}
            </td>
            <td>{d?.caseId}</td>
            <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
            <td>{moment(d?.createdAt).format("LTS")}</td>
            <td>{d?.status}</td>
            <td>
              {capitalize(d?.particularCustomer?.firstName) ||
                capitalize(d?.membership?.customer?.firstName)}
            </td>
            <td>
              {capitalize(d?.particularCustomer?.lastName) ||
                capitalize(d?.membership?.customer?.lastName)}
            </td>{" "}
            <td>
              {exists(d?.particularCustomer?.vehiclePlate) ||
                exists(d?.membership?.vehicle?.plate)}
            </td>
            <td>
              {capitalize(d?.particularCustomer?.vehicleBrand?.brand) ||
                capitalize(d?.membership?.vehicle?.brand)}
            </td>{" "}
            <td>
              {capitalize(d?.particularCustomer?.vehicleModel?.model) ||
                capitalize(d?.membership?.vehicle?.model)}
            </td>{" "}
            <td>
              {exists(d?.particularCustomer?.vehicleYear) ||
                exists(d?.membership?.vehicle?.year)}
            </td>{" "}
            <td>
              {[membershipCodes.GOLDM].includes(d?.membership?.code)
                ? capitalize(membershipCodes.GOLD)
                : capitalize(d?.membership?.code)}
            </td>
            <td>{capitalize(d?.membership?.status)}</td>
            <td>{capitalize(d?.caseType)}</td>
            <td>{capitalize(d?.fault)}</td>
            <td>{capitalize(d?.realFault)}</td>
            <td>{capitalize(d?.originState)}</td>
            <td>{capitalize(d?.originCity)}</td>
            <td>{capitalize(d?.destinyState)}</td>
            <td>{capitalize(d?.destinyCity)}</td>
            {d?.services?.map((service, j) => {
              return (
                <>
                  <td style={{ display: displayPayment }}>
                    {serviceName(service?.productCode)}
                  </td>
                  <td style={{ display: displayPayment }}>{service?.code}</td>
                  <td style={{ display: displayPayment }}>
                    {service?.provider?.isInternal === true && "Propia"}
                    {service?.provider?.isInternal === false && "Externa"}
                  </td>
                  <td style={{ display: displayPayment }}>
                    {service?.provider?.contactName}
                  </td>
                  <td style={{ display: displayPayment }}>{service?.shift}</td>
                  <td style={{ display: displayPayment }}>
                    {service?.price ? service?.price + "$" : ""}{" "}
                  </td>
                  <td style={{ display: displayPayment }}>
                    {service?.pvp ? service?.pvp + "$" : ""}{" "}
                  </td>
                  <td style={{ display: displayPayment }}>
                    {service?.paymentStatus}
                  </td>
                  {service?.payments?.map((payment, k) => {
                    return (
                      <>
                        <td style={{ display: displayPayment }}>
                          {capitalize(payment?.method)}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {payment?.totalAmount
                            ? payment?.totalAmount + "$"
                            : ""}
                        </td>
                        <td style={{ display: displayPayment }}>
                          {payment?.reference}
                        </td>
                      </>
                    );
                  })}
                </>
              );
            })}
            {d?.newStages?.map((stage, i) => {
              return <td>{reasignTime(d, i)}</td>;
            })}
            <td>{formatMinutes(d?.stageTimePendingUpload)}</td>
            <td>{formatMinutes(d?.totalTicketTimeInMin)}</td>
          </tr>
        ))}
    </table>
  );
};

export const ExportablesPaymentTable = (props) => {
  const { header, data, handlePageChange, type, tableRef } = props;
  return (
    <>
      <div className="table-container">
        <table ref={tableRef} className="table exportable-table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {[
            exportablesTypes?.PAYMENT_AV,
            exportablesTypes?.PAYMETN_INTERNAL_TOW,
            exportablesTypes?.PAYMENT_EXTERNAL_TOW,
          ].includes(type) &&
            data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                {[
                  exportablesTypes?.PAYMENT_AV,
                  exportablesTypes?.PAYMETN_INTERNAL_TOW,
                ].includes(type) && <td>{capitalize(d?.providerName)}</td>}{" "}
                {[exportablesTypes?.PAYMENT_EXTERNAL_TOW].includes(type) && (
                  <td>{capitalize(d?.providerCompany)}</td>
                )}
                <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                <td>{capitalize(d?.product)}</td>
                <td>{capitalize(d?.caseType)}</td>
                <td>{d?.authorizedBy}</td>
                <td>{capitalize(d?.alliance)}</td>
                <td>{exists(d?.code)}</td>
                <td>{exists(d?.plate) || exists(d?.vehicleData?.plate)}</td>
                <td>
                  {capitalize(d?.vehicleBrand) ||
                    capitalize(d?.vehicleData?.brand)}{" "}
                </td>
                <td>{capitalize(d?.originState)}</td>
                <td>{capitalize(d?.originCity)}</td>
                <td>{exists(d?.providerPay?.toFixed(2))}$</td>
              </tr>
            ))}
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ExportablesPendingPaymentTable = (props) => {
  const { header, data, handlePageChange, tableRef } = props;

  useEffect(() => {
    // Aplicar la función para deshabilitar copiar y menú contextual
    const cleanup = disableCopyAndContextMenu(tableRef);

    // Limpiar eventos al desmontar
    return () => cleanup && cleanup();
  }, [tableRef]);

  const sumAmount = (data, param) => {
    let total = 0;
    for (let i = 0; i < data?.length; i++) {
      total = total + data[i][param];
    }
    return total?.toFixed(2);
  };

  return (
    <>
      <div className="table-container">
        <table
          ref={tableRef}
          className="table exportable-table"
          onContextMenu={(e) => e.preventDefault()}
        >
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{d?.code}</td>
                <td>
                  {d?.serviceDate
                    ? moment(d?.serviceDate).format("DD/MM/YYYY")
                    : ""}
                </td>
                <td>{capitalize(d?.customerFullName)}</td>
                <td>{d?.allianceEnterpriseName}</td>
                <td>{exists(d?.vehiclePlate)}</td>
                <td>{exists(d?.caseType)}</td>
                <td>{capitalize(d?.isStillPendingDesc)}</td>
                <td>{d?.pendingAmount.toFixed(2)}</td>
                <td>{sumAmount(d?.payments, "totalAmount")}</td>
                <td>{sumAmount(d?.payments, "totalAmountInBsS")}</td>
                <td>
                  {d?.pendingPayment?.datePaid
                    ? moment(d?.pendingPayment?.datePaid).format("DD/MM/YYYY")
                    : ""}
                </td>
              </tr>
            ))}
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

const locksmithLinkStyle = {
  color: "#f27730",
  fontWeight: 600,
  textDecoration: "none",
};

const locksmithFileCell = (value, label) => {
  if (!value || value === "-") {
    return "-";
  }
  if (/^https?:\/\//i.test(value)) {
    return (
      <a href={value} target="_blank" rel="noreferrer" style={locksmithLinkStyle}>
        {label}
      </a>
    );
  }
  return value;
};

export const ExportablesLocksmithTable = (props) => {
  const { header, data, handlePageChange, tableRef } = props;

  return (
    <>
      <div className="table-container">
        <table ref={tableRef} className="table exportable-table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow} alt="" />
                )}
              </th>
            ))}
          </tr>
          {data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, index) => (
              <tr key={d?.codigoServicio || index}>
                <td>{d?.operador || "-"}</td>
                <td>{d?.fechaCreacion || "-"}</td>
                <td>{d?.codigoServicio || "-"}</td>
                <td>{d?.estatus || "-"}</td>
                <td>{d?.cliente || "-"}</td>
                <td>{d?.placa || "-"}</td>
                <td>{d?.ciudadOrigen || "-"}</td>
                <td>{d?.proveedorRecomendado || "-"}</td>
                <td>
                  {d?.costoServicio !== undefined &&
                    d?.costoServicio !== null &&
                    d?.costoServicio !== "" &&
                    d?.costoServicio !== "-" &&
                    !Number.isNaN(Number(d.costoServicio))
                    ? Number(d.costoServicio).toFixed(2)
                    : "-"}
                </td>
                <td>{locksmithFileCell(d?.factura, "Ver factura")}</td>
                <td>{d?.reembolso || "-"}</td>
                <td>{d?.referenciaReembolso || "-"}</td>
                <td>
                  {locksmithFileCell(d?.comprobanteReembolso, "Ver comprobante")}
                </td>
              </tr>
            ))}
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit) || 1}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ExportablesFollowUpTable = (props) => {
  const { header, data, handlePageChange, tableRef } = props;

  const ScheduledComponent = (tracking) => {
    if (tracking?.services?.length <= 0) {
      return null;
    }

    let data = [];

    for (let i = 0; i < 5; i++) {
      data.push({
        scheduled: tracking?.services[i]?.scheduled || "",
        when: tracking?.services[i]?.when || "",
        status: tracking?.services[i]?.status || "",
        channel: tracking?.services[i]?.channel || "",
        user: tracking?.services[i]?.user || "",
        note: tracking?.services[i]?.note || "",
      });
    }

    return (
      <>
        {data?.map((d, i) => (
          <>
            <td>
              {d?.scheduled
                ? moment(d?.scheduled)?.format("DD/MM/YYYY LTS")
                : ""}
            </td>
            <td>{d?.when ? moment(d?.when)?.format("DD/MM/YYYY LTS") : ""}</td>
            <td>{d?.channel} </td>
            <td>{capitalize(d?.user)} </td>
            <td>{d?.note} </td>
          </>
        ))}
      </>
    );
  };

  return (
    <>
      <div className="table-container">
        <table ref={tableRef} className="table exportable-table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => (
              <tr key={d?.caseId}>
                <td>
                  {capitalize(d?.createdBy[0]?.firstName)}{" "}
                  {capitalize(d?.createdBy[0]?.lastName)}
                </td>
                <td>
                  {capitalize(d?.user?.firstName)}{" "}
                  {capitalize(d?.user?.lastName)}
                </td>
                <td>{d?.caseId}</td>
                <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                <td>{d?.status}</td>
                <td>
                  {capitalize(d?.particularCustomer?.firstName) ||
                    capitalize(d?.membership?.customer?.firstName)}{" "}
                  {capitalize(d?.particularCustomer?.lastName) ||
                    capitalize(d?.membership?.customer?.lastName)}
                </td>
                <td>{d?.phone}</td>
                <td>
                  {exists(d?.particularCustomer?.vehiclePlate) ||
                    exists(d?.membership?.vehicle?.plate)}
                </td>
                <td>
                  {d?.services[0]?.tracking[0]?.scheduled &&
                    moment(d?.services[0]?.tracking[0]?.scheduled).format(
                      "DD/MM/YYYY"
                    )}
                </td>
                <td>{capitalize(d?.originState)}</td>
                <td>{capitalize(d?.originCity)}</td>
                <td>{capitalize(d?.destinyState)}</td>
                <td>{capitalize(d?.destinyCity)}</td>
                <td>{d?.services[0]?.code}</td>

                <ScheduledComponent
                  services={
                    d?.services?.length > 0 ? d?.services[0]?.tracking : []
                  }
                />
              </tr>
            ))}
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ExportableAdministrationTable = (props) => {
  const { header, data, handlePageChange, tableRef } = props;

  return (
    <>
      <div className="table-exportable-container">
        <div className="table-exportable-content">
          <table ref={tableRef} className="table exportable-table">
            <tr>
              {header?.map((h) => (
                <th key={h?.name}>
                  {h?.name}
                  {h?.sortable && (
                    <img
                      style={{ cursor: "pointer" }}
                      src={navOptionArrow}
                    ></img>
                  )}
                </th>
              ))}
            </tr>
            {data?.data.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d) => {
                return (
                  <tr key={d?._id}>
                    <td>
                      {d?.payCreatedAtLocale ? d?.payCreatedAtLocale : ""}
                    </td>
                    <td>{capitalize(d?.caseType)}</td>
                    <td>{capitalize(d?.caseCustomerFailureDesc)}</td>
                    <td>{capitalize(d?.caseProviderFailureDesc)}</td>
                    <td>{capitalize(d?.productDesc)}</td>
                    <td>{d?.serviceCode}</td>
                    <td>
                      {d?.serviceCreatedAtLocale
                        ? d?.serviceCreatedAtLocale
                        : ""}
                    </td>
                    <td>{d?.incomeType}</td>
                    <td>{d?.servicePaymentStatus}</td>
                    <td>{d?.pendingPaymentStatus}</td>
                    <td>{d?.serviceTotalAmount}</td>
                    <td>{d?.serviceTotalAmountBs}</td>
                    <td>{d?.serviceAmount}</td>
                    <td>{d?.serviceAmountBs}</td>
                    <td>{d?.ivaAmount}</td>
                    <td>{d?.payTotalAmount}</td>
                    <td>{d?.payTotalAmountInBsS}</td>
                    <td>{capitalize(d?.payMethodDesc)}</td>
                    <td>{d?.payRef}</td>
                    <td>{d?.cashReceiverName}</td>
                    <td>{d?.pendingPaymentAmount}</td>
                    <td>{d?.totalChange}</td>
                    <td>{d?.change1Usd}</td>
                    <td>{d?.change1Bs}</td>
                    <td>{capitalize(d?.change1Method)}</td>
                    <td>{d?.change1Ref}</td>

                    <td>{d?.change2Usd}</td>
                    <td>{d?.change2Bs}</td>
                    <td>{capitalize(d?.change2Method)}</td>
                    <td>{d?.change2Ref}</td>

                    <td>{d?.change3Usd}</td>
                    <td>{d?.change3Bs}</td>
                    <td>{capitalize(d?.change3Method)}</td>
                    <td>{d?.change3Ref}</td>
                    <td>{d?.validated}</td>
                  </tr>
                );
              })}
          </table>
        </div>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const PaymentsValidationTable = (props) => {
  const { header, data, handlePageChange, onValidate } = props;

  return (
    <>
      <div className="table-exportable-container">
        <div style={{ width: "100%" }} className="table-exportable-content">
          <table className="table">
            <tr>
              {header?.map((h) => (
                <th key={h?.value || h?.name}>{h?.name}</th>
              ))}
            </tr>
            {data?.data?.length > 0 &&
              !data?.isLoading &&
              data?.data?.map((d, index) => {
                return (
                  <tr key={d?._id || d?.id || `${d?.service?.code}-${index}`}>
                    <td>{d?.service?.code}</td>
                    <td>
                      {d?.createdAt
                        ? moment(d?.createdAt).isValid()
                          ? moment(d?.createdAt).format("DD/MM/YYYY")
                          : d?.createdAt
                        : ""}
                    </td>
                    <td>{capitalize(d?.service?.createdBy?.firstName + " " + d?.service?.createdBy?.lastName)}</td>
                    <td>{d?.service?.pvp}</td>
                    <td>{d?.totalAmount}</td>
                    <td>{d?.totalAmountInBsS}</td>
                    <td>{capitalize(d?.method?.method)}</td>
                    <td>{d?.reference}</td>
                    <td>{capitalize(d?.accHolder)}</td>
                    <td>
                      {d?.referenceImg && (
                        <a href={d?.referenceImg} target="_blank" rel="noreferrer">
                          ver comprobante
                        </a>
                      )}
                    </td>
                    <td>{capitalize(d?.service?.productAfiliado?.product) || capitalize(d?.service?.particularProduct?.product)}</td>
                    <td>
                      {d?.validated ? "" :
                        <ActionButton
                          label={"Validar pago"}
                          action={() => onValidate && onValidate(d)}
                        // style={{ padding: "4px 10px", minWidth: "90px" }}
                        />
                      }
                    </td>
                  </tr>
                );
              })}
          </table>
        </div>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data?.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ProvidersPaymentTable = (props) => {
  const {
    header,
    handleMultiplePayments,
    handleMultipleConciliation,
    data,
    handlePageChange,
    type,
    tableRef,
    selectPayment,
    selectConciliate,
    paid,
    conciliated,
  } = props;

  const validateIfCanPay = (data, payment, index, type) => {
    if ([exportablesTypes?.PAYMENT_AV]?.includes(type) && !payment?.invoice) {
      return (
        <Checkbox
          payments={data}
          payment={payment}
          select={selectPayment}
          index={index}
          param={paymentsSelectionEnum?.PAY}
          type={type}
        />
      );
    }
    if (
      [exportablesTypes?.PAYMETN_INTERNAL_TOW]?.includes(type) &&
      !payment?.invoice &&
      payment?.providerReconciledByName
    ) {
      return (
        <Checkbox
          payments={data}
          payment={payment}
          select={selectPayment}
          index={index}
          param={paymentsSelectionEnum?.PAY}
          type={type}
        />
      );
    }

    if (
      [exportablesTypes?.PAYMENT_EXTERNAL_TOW]?.includes(type) &&
      !payment?.invoice &&
      payment?.providerReconciled
    ) {
      return (
        <Checkbox
          payments={data}
          payment={payment}
          select={selectPayment}
          index={index}
          param={paymentsSelectionEnum?.PAY}
        />
      );
    }

    // if (
    //   [exportablesTypes?.PAYMETN_INTERNAL_TOW]?.includes(type) &&
    //   !payment?.providerPaidByName &&
    //   payment?.providerReconciledByName
    // ) {
    //   return (
    //     <Checkbox
    //       payments={data}
    //       payment={payment}
    //       select={selectPayment}
    //       index={index}
    //       param={paymentsSelectionEnum?.PAY}
    //     />
    //   );
    // }
  };
  return (
    <>
      <div className="table-container">
        <table ref={tableRef} className="table exportable-table">
          <tr>
            {[
              providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
              providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
            ].includes(type) && (
                <th>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <p style={{ marginRight: "5px" }}>Conciliar</p>
                    {[
                      providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
                      providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
                    ].includes(type) && (
                        <TableFilter
                          label={"Conciliar"}
                          options={[
                            { name: "Conciliado", _id: "Conciliado" },
                            { name: "No conciliado", _id: "No conciliado" },
                          ]}
                          onSearch={conciliated}
                        />
                      )}
                    <SelectAllCheckbox
                      data={data}
                      handleMultipleSelection={handleMultipleConciliation}
                      param={paymentsSelectionEnum?.CONCILIATE}
                    />
                  </div>
                </th>
              )}
            <th>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <p style={{ marginRight: "5px" }}>Pagar</p>
                {[
                  providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
                  providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
                ].includes(type) && (
                    <TableFilter
                      label={"Conciliar"}
                      options={[
                        { name: "Pagado", _id: "Pagado" },
                        { name: "No pagado", _id: "No pagado" },
                      ]}
                      onSearch={paid}
                    />
                  )}
                <SelectAllCheckbox
                  data={data}
                  handleMultipleSelection={handleMultiplePayments}
                  param={paymentsSelectionEnum?.PAY}
                />
              </div>
            </th>
            {header?.map((h) => (
              <th key={h?.name}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <p style={{ marginRight: "5px" }}>{h?.name}</p>

                  {h?.sortable &&
                    [
                      providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW,
                      providersPaymentsTypes?.PAYMETN_INTERNAL_TOW,
                    ].includes(type) && (
                      <TableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onSearch={h.filterSearch}
                      />
                    )}
                </div>
              </th>
            ))}
            {[exportablesTypes?.PAYMENT_EXTERNAL_TOW].includes(type) && (
              <>
                <th>Comprobante de pago 1</th>
                <th>Comprobante de pago 2</th>
                <th>Gruero en origen</th>
                <th>Vehículo en grúa</th>
                <th>Vehículo en destino</th>
              </>
            )}
          </tr>
          {[
            exportablesTypes?.PAYMENT_AV,
            exportablesTypes?.PAYMETN_INTERNAL_TOW,
            exportablesTypes?.PAYMENT_EXTERNAL_TOW,
          ].includes(type) &&
            data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => (
              <tr key={d?._id}>
                {[providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(
                  type
                ) && (
                    <td>
                      {!d?.providerReconciled && !d?.invoice && (
                        <Checkbox
                          payments={data?.data}
                          payment={d}
                          select={selectConciliate}
                          index={i}
                          param={paymentsSelectionEnum?.CONCILIATE}
                        />
                      )}
                    </td>
                  )}
                {[providersPaymentsTypes?.PAYMETN_INTERNAL_TOW].includes(
                  type
                ) && (
                    <td>
                      {!d?.providerReconciledByName && !d?.providerPaidByName && (
                        <Checkbox
                          payments={data?.data}
                          payment={d}
                          select={selectConciliate}
                          index={i}
                          param={paymentsSelectionEnum?.CONCILIATE}
                        />
                      )}
                    </td>
                  )}
                <td>{validateIfCanPay(data?.data, d, i, type)}</td>
                {[
                  exportablesTypes?.PAYMENT_AV,
                  exportablesTypes?.PAYMETN_INTERNAL_TOW,
                ].includes(type) && <td>{capitalize(d?.providerName)}</td>}{" "}
                {[exportablesTypes?.PAYMENT_EXTERNAL_TOW].includes(type) && (
                  <td>{capitalize(d?.providerCompany)}</td>
                )}
                <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                <td>{capitalize(d?.product)}</td>
                <td>{capitalize(d?.caseType)}</td>
                <td>{capitalize(d?.allianceEnterpriseName)}</td>
                <td>{exists(d?.code)}</td>
                <td>{exists(d?.plate)}</td>
                <td>{capitalize(d?.vehicleBrand)}</td>
                <td>{capitalize(d?.originState)}</td>
                <td>{capitalize(d?.originCity)}</td>
                {[
                  exportablesTypes?.PAYMETN_INTERNAL_TOW,
                  exportablesTypes?.PAYMENT_EXTERNAL_TOW,
                ].includes(type) ? (
                  <td>{d?.price?.toFixed(2)}$</td>
                ) : (
                  ""
                )}
                {[exportablesTypes?.PAYMENT_AV].includes(type) && (
                  <>
                    <td>{d?.solvedByAVDesc}</td>
                    <td>{d?.solvedFaultStatus}</td>
                  </>
                )}
                <td>{exists(d?.providerPay?.toFixed(2))}$</td>
                <td>
                  {d?.providerPaymentStatus ? d?.providerPaymentStatus : ""}
                </td>
                <td>
                  {d?.providerReconciledAt &&
                    moment(d?.providerReconciledAt).format("DD/MM/YYYY")}{" "}
                </td>
                <td>{capitalize(d?.providerReconciledByName)}</td>
                <td>
                  {d?.invoice?.paymentDate
                    ? moment(d?.invoice?.paymentDate).format("DD/MM/YYYY")
                    : ""}
                </td>
                <td>
                  {d?.providerPaymentDate
                    ? moment(d?.providerPaymentDate).format("DD/MM/YYYY")
                    : ""}
                </td>
                <td>{capitalize(d?.providerPaidByName)}</td>
                <td>{d?.invoice ? d?.invoice?.receipt : ""}</td>
                <td>{d?.invoice ? d?.invoice?.billNumber : ""}</td>
                <td>
                  {d?.invoice ? (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={d?.invoice?.receiptPath}
                    >
                      <img src={factura} alt="factura" />
                    </a>
                  ) : (
                    ""
                  )}
                </td>{" "}
                {[exportablesTypes?.PAYMENT_EXTERNAL_TOW].includes(type) && (
                  <>
                    <td>
                      {d?.invoice?.paymentData?.[0]?.file ? (
                        <a
                          target="_blank"
                          href={d?.invoice?.paymentData?.[0]?.file}
                          rel="noreferrer"
                        >
                          Comprobante de pago
                        </a>
                      ) : null}
                    </td>
                    <td>
                      {d?.invoice?.paymentData?.[1]?.file ? (
                        <a
                          target="_blank"
                          href={d?.invoice?.paymentData?.[1]?.file}
                          rel="noreferrer"
                        >
                          Comprobante de pago
                        </a>
                      ) : null}
                    </td>
                    <td>
                      {d?.towImages?.towAtOrigin ? (
                        <a
                          target="_blank"
                          href={d?.towImages?.towAtOrigin}
                          rel="noreferrer"
                        >
                          Gruero en origen
                        </a>
                      ) : null}
                    </td>
                    <td>
                      {d?.towImages?.vehicleOnTow ? (
                        <a
                          target="_blank"
                          href={d?.towImages?.vehicleOnTow}
                          rel="noreferrer"
                        >
                          Vehículo en grúa
                        </a>
                      ) : null}
                    </td>
                    <td>
                      {d?.towImages?.vehicleOnRoad ? (
                        <a
                          target="_blank"
                          href={d?.towImages?.vehicleOnRoad}
                          rel="noreferrer"
                        >
                          Vehículo en destino
                        </a>
                      ) : null}
                    </td>
                  </>
                )}
              </tr>
            ))}
          {[providersPaymentsTypes?.PAYMENT_EXTERNAL_TOW].includes(type) &&
            data?.data.length < 5 && (
              <div
                style={{
                  marginBottom: "250px",
                  backgroundColor: "transparent",
                }}
              ></div>
            )}
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const ParticularCounterTable = (props) => {
  const { header, data, type, tableRef, userRole } = props;

  const calculateTotal = (data, param) => {
    let total = 0;
    for (let i = 0; i < data?.length; i++) {
      total = total + data[i][param];
    }
    return total;
  };

  return (
    <>
      <div className="table-container particular-counter-table-container">
        <table ref={tableRef} className="table  exportable-table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {[
            exportablesTypes?.PAYMENT_AV,
            exportablesTypes?.PAYMETN_INTERNAL_TOW,
            exportablesTypes?.PAYMENT_EXTERNAL_TOW,
          ].includes(type) &&
            data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => (
              <tr key={d?._id}>
                <td>
                  {capitalize(d?.firstName) + " " + capitalize(d?.lastName)}
                </td>

                {![operationsRoles.operationsOperator].includes(userRole) && (
                  <>
                    <td>{d?.activeServices}</td>
                    <td>{d?.doneServices}</td>
                  </>
                )}
                <td>{d?.towServiceInternal}</td>
                <td>{d?.towServiceExternal}</td>
                <td>{d?.towServiceExternalCcs}</td>
                <td>{d?.towServiceExternalIn}</td>
                <td>{d?.towServices}</td>
                <td>{d?.avServices}</td>
                <td>{d?.totalServices} </td>
              </tr>
            ))}
          <tr>
            <td>
              <b>Total</b>
            </td>
            {![operationsRoles.operationsOperator].includes(userRole) && (
              <>
                <td>
                  <b>{calculateTotal(data?.data, "activeServices")}</b>
                </td>
                <td>
                  <b>{calculateTotal(data?.data, "doneServices")}</b>
                </td>
              </>
            )}
            <td>
              <b>{calculateTotal(data?.data, "towServiceInternal")}</b>
            </td>

            <td>
              <b>{calculateTotal(data?.data, "towServiceExternal")}</b>
            </td>
            <td>
              <b>{calculateTotal(data?.data, "towServiceExternalCcs")}</b>
            </td>
            <td>
              <b>{calculateTotal(data?.data, "towServiceExternalIn")}</b>
            </td>

            <td>
              <b>{calculateTotal(data?.data, "towServices")}</b>
            </td>
            <td>
              <b>{calculateTotal(data?.data, "avServices")}</b>
            </td>
            <td>
              <b>{calculateTotal(data?.data, "totalServices")}</b>
            </td>
          </tr>
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      {/* <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div> */}
    </>
  );
};

export const SupervisorParticularCounterTable = (props) => {
  const { header, data, tableRef } = props;

  return (
    <div style={{ display: "flex", flexDirection: "column", margin: "25px 0" }}>
      <div
        className="table-container particular-counter-table-container"
        style={{
          margin: "0 auto",
          width: "50%",
        }}
      >
        <table ref={tableRef} className="table  exportable-table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.fullName)}</td>
                <td>{d?.count}</td>
                <td>{d?.totalAmount}</td>
              </tr>
            ))}
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
    </div>
  );
};

export const InernalProvidersTable = (props) => {
  const {
    externalHeader,
    internalHeader,
    handlePageChange,
    data,
    assignTow,
    internal,
    scheduleDate
  } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {internal ? (
              <>
                {internalHeader.map((h) => (
                  <th key={h?.value}>
                    {h?.name}
                    {h?.sortable && (
                      <img
                        style={{ cursor: "pointer" }}
                        src={navOptionArrow}
                      ></img>
                    )}
                  </th>
                ))}
              </>
            ) : (
              <>
                {externalHeader.map((h) => (
                  <th key={h?.value}>
                    {h?.name}
                    {h?.sortable && (
                      <img
                        style={{ cursor: "pointer" }}
                        src={navOptionArrow}
                        alt="image"
                      ></img>
                    )}
                  </th>
                ))}
              </>
            )}
          </tr>
          {data?.data?.map((d) => (
            <tr key={d?._id}>
              <td>
                <img
                  onClick={() => assignTow(d)}
                  style={{ cursor: "pointer" }}
                  src={add}
                  alt="add"
                />
              </td>
              {!internal && <td>{capitalize(d?.companyName)}</td>}
              <td>{capitalize(d?.contactName)}</td>
              {(internal && scheduleDate) && <td>{d?.time ? `${d?.time.toFixed(2)} min` : 'N/A'}</td>}
              {!scheduleDate ? <td>{d?.time ? `${d?.time.toFixed(2)} min` : ""}</td> : null}
              {!scheduleDate ? <td>{d?.scheduled ? "Si" : "No"}</td> : null}
              <td>{exists(d?.phonePrefix) + "-" + exists(d?.phoneNumber)}</td>
              <td>
                {exists(d?.identificationType) +
                  ": " +
                  exists(d?.identification)}
              </td>

              <td>{capitalize(d?.state)}</td>
              <td>{d?.isActive}</td>
            </tr>
          ))}
        </table>
      </div>
      {scheduleDate &&
        <div className="pagination-container">
          <Pagination
            count={Math.ceil(data?.count / data?.limit)}
            variant="outlined"
            shape="rounded"
            page={data?.page}
            onChange={handlePageChange}
          />
        </div>
      }
    </>
  );
};

export const ProvidersTable = (props) => {
  const {
    externalHeader,
    internalHeader,
    data,
    assignTow,
    handlePageChange,
    internal,
  } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {internal ? (
              <>
                {internalHeader.map((h) => (
                  <th key={h?.value}>
                    {h?.name}
                    {h?.sortable && (
                      <img
                        style={{ cursor: "pointer" }}
                        src={navOptionArrow}
                      ></img>
                    )}
                  </th>
                ))}
              </>
            ) : (
              <>
                {externalHeader.map((h) => (
                  <th key={h?.value}>
                    {h?.name}
                    {h?.sortable && (
                      <img
                        style={{ cursor: "pointer" }}
                        src={navOptionArrow}
                        alt="image"
                      ></img>
                    )}
                  </th>
                ))}
              </>
            )}
          </tr>
          {data?.data?.map((d) => (
            <tr key={d?._id}>
              <td>
                <img
                  onClick={() => assignTow(d)}
                  style={{ cursor: "pointer" }}
                  src={add}
                  alt="add"
                />
              </td>
              {!internal && <td>{capitalize(d?.companyName)}</td>}
              <td>{capitalize(d?.contactName)}</td>
              <td>{exists(d?.phonePrefix) + "-" + exists(d?.phoneNumber)}</td>
              <td>
                {exists(d?.identificationType) +
                  ": " +
                  exists(d?.identification)}
              </td>

              <td>{capitalize(d?.state)}</td>
              <td>{d?.isActive}</td>
            </tr>
          ))}
        </table>
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const InternalProviderTable = (props) => {
  const { header, dataTable, handlePageChange, edit, activateProvider } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.contactName)}</td>
                <td>{capitalize(d?.type)}</td>
                <td>{exists(d?.phonePrefix) + "-" + exists(d?.phoneNumber)}</td>
                <td>
                  {exists(d?.identificationType) +
                    ": " +
                    exists(d?.identification)}
                </td>
                <td>{capitalize(d?.state)}</td>
                <td>
                  {d?.vehicle
                    ? capitalize(d?.vehicle?.alias) + " " + d?.vehicle?.plate
                    : ""}
                </td>
                <td>{exists(d?.isActive)}</td>
                <td>
                  <div className="table-buttons-conatiner">
                    {/* <TableActionButton src={view} /> */}
                    <TableActionButton src={editLogo} action={() => edit(d)} />
                    <SwitchComponent
                      data={d}
                      active={d?.isActive === "Activo"}
                      action={activateProvider}
                    />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const VehicularAssetsTable = (props) => {
  const { header, dataTable, handlePageChange, edit } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id}>
                <td>{capitalize(d?.class)}</td>
                <td>{capitalize(d?.brand)}</td>
                <td>{capitalize(d?.model)}</td>
                <td>{capitalize(d?.color)}</td>
                <td>{exists(d?.type)}</td>
                <td>{capitalize(d?.alias)}</td>
                <td>{exists(d?.plate)}</td>
                <td>{exists(d?.year)}</td>
                <td>
                  {d?.purchaseDate
                    ? moment(d?.purchaseDate).format("DD/MM/YYYY")
                    : ""}
                </td>
                <td>{exists(d?.description)}</td>
                <td>
                  <div className="table-buttons-conatiner">
                    {/* <TableActionButton src={view} /> */}
                    <TableActionButton src={editLogo} action={() => edit(d)} />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const IncidenceTable = (props) => {
  const { header, data, title } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="incidence-table table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>
          {data?.map((d) => (
            <tr key={d?._id}>
              <td>
                {d?.createdAt ? moment(d?.createdAt).format("DD/MM/YYYY") : ""}
              </td>
              <td>{capitalize(d?.fault)}</td>
              <td>
                {d?.service ? capitalize(d?.service) : capitalize(d?.type)}
              </td>
              <td>{d?.providerFailureDescription}</td>
              <td>{d?.exceptionReason?.name}</td>
              <td>
                {d?.serviceKm || d?.serviceKm == 0
                  ? d?.serviceKm + " Km"
                  : "N/A"}
              </td>
            </tr>
          ))}
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const FollowingTable = (props) => {
  const { header, data, title } = props;

  return (
    <div className="incidence-table-section-container">
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="incidence-table table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>
          {data?.map((d) => (
            <tr key={d?._id}>
              <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
              <td>{moment(d?.createdAt).format("LTS")}</td>
              <td>{exists(d?.stage)}</td>
              <td>{d?.type}</td>
              <td>{exists(d?.message)}</td>
              <td>{exists(d?.note)}</td>
            </tr>
          ))}
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
      </div>
    </div>
  );
};

export const OperationsUserTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    tableRef,
    handleEditFleetForm,
  } = props;

  const getShift = (shift) => {
    let shiftPopulated = "";

    switch (shift) {
      default:
        shiftPopulated = "";
        break;
      case "Turno 1: Lunes a Viernes 7am-1pm":
        shiftPopulated = `${"Turno 1:"}<br/>${"Lunes a Viernes"}<br/>${"7:00am - 1:00pm"}`;
        break;
      case "Turno 2: Lunes a Viernes 1pm-7pm":
        shiftPopulated = `${"Turno 2:"}<br/>${"Lunes a Viernes"}<br/>${"1:00pm - 7:00pm"}`;
        break;
      case "Turno 3: Interdiario 7pm-7am":
        shiftPopulated = `${"Turno 3:"}<br/>${"Interdiario"}<br/>${"7:00pm - 7:00am"}`;
        break;
      case "Turno 4: Fines de semana 7am-3pm":
        shiftPopulated = `${"Turno 4:"}<br/>${"Fines de semana"}<br/>${"7:00am - 3:00pm"}`;
        break;
      case "Turno 5: Fines de semana 2pm-9pm":
        shiftPopulated = `${"Turno 5:"}<br/>${"Fines de semana"}<br/>${"2:00pm - 9:00pm"}`;
        break;
      case "Turno 1: 7:00 am a 4:00 pm":
        shiftPopulated = `${"Turno 1:"}<br/>${"7:00 am - 4:00 pm"}`;
        break;
      case "Turno 2: 4:00 pm a 10:00 pm":
        shiftPopulated = `${"Turno 2:"}<br/>${"4:00pm - 10:00 pm"}`;
        break;
    }

    return shiftPopulated;
  };

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table ref={tableRef} className="table">
          <tr>
            {header?.map((h) => (
              <th style={{ textAlign: "center" }} key={h?.name}>
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id} style={{ textAlign: "center" }}>
                  <td>
                    {capitalize(d?.firstName)} {capitalize(d?.lastName)}
                  </td>
                  <td>{d?.email}</td>
                  <td>{transcriptRoles(d?.role)}</td>
                  <td
                    dangerouslySetInnerHTML={{ __html: getShift(d?.shift) }}
                  ></td>
                  <td>{capitalize(d?.provider?.contactName)}</td>
                  <td>{d?.status}</td>
                  <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                  <td>{moment(d?.updatedAt).format("DD/MM/YYYY")}</td>

                  <td>
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={editLogo}
                        action={() => handleEditFleetForm(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const SalesUserTable = (props) => {
  const {
    header,
    data,
    title,
    handlePageChange,
    tableRef,
    handleEditFleetForm,
  } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table ref={tableRef} className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>
                    {d?.firstName} {d?.lastName}
                  </td>
                  <td>{d?.email}</td>
                  <td>{transcriptRoles(d?.role)}</td>
                  <td>{d?.status}</td>
                  <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                  <td>{moment(d?.updatedAt).format("DD/MM/YYYY")}</td>

                  <td>
                    <div className="table-buttons-conatiner">
                      <TableActionButton
                        src={editLogo}
                        action={() => handleEditFleetForm(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const CancelServicesTable = (props) => {
  const { header, data, cancelService } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>{h?.name}</th>
            ))}
          </tr>
          {data?.length > 0 &&
            data?.map((d) => {
              return (
                <tr key={d?._id}>
                  <td>{d?.type}</td>
                  <td>{capitalize(d?.provider?.contactName)}</td>
                  <td>{d?.status}</td>
                  <td>{d?.code}</td>
                  <td>
                    <div className="buttons-center-container">
                      <ActionButton
                        label={"Cancelar"}
                        action={() => cancelService(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
    </>
  );
};

export const EditServicePaymentTable = (props) => {
  const { header, data, handleEditPayment } = props;

  if (data?.length === 0) {
    return null;
  }

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="table-container">
        <table className="table">
          <tr>
            {header?.map((h) => (
              <th
                style={{ fontSize: "12px", textAlign: "center" }}
                key={h?.name}
              >
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.length > 0 &&
            data?.map((d, i) => {
              return (
                <tr
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                  key={d?._id}
                >
                  <td>Pago {i + 1}</td>
                  <td>{d?.amount}</td>
                  <td>{d?.totalAmountInBsS}</td>
                  <td>{capitalize(d?.method[0]?.method)}</td>
                  {/* <td>{d?.status}</td> */}
                  <td>{d?.reference}</td>
                  <td>{d?.accHolder}</td>
                  <td>{d?.cashReceiver?.name}</td>
                  <td>
                    {d?.referenceImg && (
                      <a
                        href={d?.referenceImg}
                        target="_blank"
                        rel="noreferrer"
                      >
                        comprobante
                      </a>
                    )}
                  </td>
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td>{d?.siblingMemberships[0]}</td>
                  <td>
                    <div className="buttons-center-container">
                      <ActionButton
                        label={"Editar"}
                        action={() => handleEditPayment(d)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
    </>
  );
};

export const TrazeTable = (props) => {
  const { header, data, title } = props;
  return (
    <div className="incidence-table-section-container">
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="incidence-table table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>{h?.name}</th>
            ))}
          </tr>
          {data?.map((d) => {
            return (
              <tr key={d?._id}>
                <td>{moment(d?.createdAt).format("DD/MM/YYYY")}</td>
                <td>{moment(d?.createdAt).format("LTS")}</td>
                <td>{d?.stage?.stage}</td>
                <td>{calculateDuration(d)}</td>
              </tr>
            );
          })}
        </table>
        {data?.length <= 0 && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
      </div>
    </div>
  );
};
export const CounterTable = (props) => {
  const { header, dataTable, userRole } = props;

  let externalCounter = {
    num: 0,
    amount: 0,
  };

  if ([operationsRoles.OPERATIONS_FLOTA_GRUA_EXT].includes(userRole)) {
    for (let i = 0; i < dataTable.length; i++) {
      externalCounter.num += dataTable[i].num;
      externalCounter.amount += dataTable[i].amount;
    }
  }

  return (
    <>
      <div className="table-container">
        <table className="table mobile-table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {dataTable?.length > 0 && !dataTable?.isLoading && (
            <>
              {![operationsRoles.OPERATIONS_FLOTA_GRUA_EXT].includes(
                userRole
              ) ? (
                dataTable?.map((d) => (
                  <tr key={d?._id}>
                    <td>{capitalize(d?.product?.product)}</td>
                    <td>{d?.num}</td>
                    <td>{Number(d?.amount).toFixed(2)} $</td>
                  </tr>
                ))
              ) : (
                <tr key={externalCounter.num}>
                  <td>{capitalize("Grua")}</td>
                  <td>{externalCounter?.num}</td>
                  <td>{Number(externalCounter?.amount).toFixed(2)} $</td>
                </tr>
              )}
            </>
          )}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
    </>
  );
};

export const AVStatstable = (props) => {
  const { header, dataTable, user, handlePageChange, userRole } = props;

  const filterServices = (data, atribute) => {
    const filterData = data?.services?.find(
      (d) => d?.provider?._id === user?.provider?._id
    );

    if (!filterData) {
      return undefined;
    }

    if (atribute === "scheduleDate" && data?.scheduleDate) {
      return moment(data.createdAt).format("DD/MM/YYYY");
    }
    if (atribute === "createdAt" && data?.createdAt) {
      return moment(data.createdAt).format("DD/MM/YYYY");
    }

    if (atribute === "plate") {
      let plate =
        data?.membership?.vehicle?.plate ||
        data?.particularCustomer?.vehiclePlate ||
        data?.vehicleData?.plate;
      return plate;
    }
    if (atribute === "product") {
      return capitalize(filterData?.product?.name);
    }
    if (atribute === "providerPay") {
      return filterData?.providerPay?.toFixed(2);
    }
    if (atribute === "providerPaymentStatus") {
      return filterData?.providerPaymentStatus;
    }
    if (atribute === "price") {
      return filterData?.price;
    }
    if (atribute === "providerReconciled") {
      return filterData.providerReconciled ? "conciliado" : "no conciliado";
    }
    if (atribute === "providerPaymentDate" && filterData?.providerPaymentDate) {
      return moment(filterData.providerPaymentDate).format("DD/MM/YYYY");
    }

    if (atribute === "paymentRef1") {
      return filterData?.invoicePayment?.paymentData?.[0]?.file
        ? filterData?.invoicePayment?.paymentData?.[0]?.file
        : "";
    }

    if (atribute === "paymentRef2") {
      return filterData?.invoicePayment?.paymentData?.[1]?.file
        ? filterData?.invoicePayment?.paymentData?.[1]?.file
        : "";
    }

    return filterData[atribute];
  };
  return (
    <>
      <div className="table-container">
        <table className="table mobile-table">
          <tr>
            {header.map((h) => (
              <th key={h?.value}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {dataTable?.data?.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data?.map((d) => (
              <tr key={d?._id}>
                <td>{filterServices(d, "product")}</td>
                <td>{filterServices(d, "code")}</td>
                <td>{filterServices(d, "plate")}</td>
                <td>
                  {filterServices(d, "scheduleDate") ||
                    filterServices(d, "createdAt")}
                </td>
                {[
                  operationsRoles?.OPERATIONS_FLOTA_AV,
                  operationsRoles?.OPERATIONS_FLOTA_GRUA,
                ].includes(user?.roles[0]?.code) && (
                    <td>{d?.solvedByAV ? "Si" : "No"}</td>
                  )}
                {[operationsRoles?.OPERATIONS_FLOTA_GRUA].includes(
                  user?.roles[0]?.code
                ) && <td>{filterServices(d, "price")}</td>}
                {[operationsRoles?.OPERATIONS_FLOTA_AV].includes(
                  user?.roles[0]?.code
                ) && <td>{d?.solvedFaultStatus}</td>}
                <td>{filterServices(d, "providerPay")}</td>
                <td>{filterServices(d, "providerPaymentStatus")}</td>
                {[operationsRoles.OPERATIONS_FLOTA_GRUA_EXT].includes(
                  userRole
                ) && (
                    <>
                      <td>{filterServices(d, "providerPaymentDate")}</td>
                      <td>{filterServices(d, "providerReconciled")}</td>
                      <td>
                        {filterServices(d, "paymentRef1") && (
                          <a
                            href={filterServices(d, "paymentRef1")}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Comprobante de pago 1
                          </a>
                        )}
                      </td>
                      <td>
                        {filterServices(d, "paymentRef2") && (
                          <a
                            href={filterServices(d, "paymentRef2")}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Comprobante de pago 2
                          </a>
                        )}
                      </td>
                    </>
                  )}
              </tr>
            ))}
        </table>
      </div>
      {/* {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />} */}
      {dataTable?.data?.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const FleetMaintenanceTable = (props) => {
  const { header, data, title, handlePageChange, action } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => (
              <th
                key={h?.name}
                style={{
                  padding: "4px 8px 4px 8px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "7px",
                    width: "100%",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr
                  key={d?._id}
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <td>{capitalize(d?.type)}</td>
                  <td>
                    {d?.unit ? `${d?.unit?.alias} - ${d?.unit?.plate}` : ""}
                  </td>
                  <td>{capitalize(d?.unitStatus)}</td>
                  <td>{capitalize(d?.maintenanceType)}</td>

                  <td>{d?.systemId ? capitalize(d?.systemId?.name) : ""}</td>
                  <td>
                    {d?.componentId ? capitalize(d?.componentId.name) : ""}
                  </td>
                  <td>{d?.comment}</td>
                  <td>{d?.km}</td>
                  <td>{d?.cost}</td>
                  <td>
                    {d?.provider ? capitalize(d?.provider.description) : ""}
                  </td>
                  <td>
                    {d?.dateIn
                      ? moment(d?.dateIn).format("DD-MM-YYYY HH:mm")
                      : ""}
                  </td>
                  <td>
                    {d?.dateOut
                      ? moment(d?.dateOut).format("DD-MM-YYYY HH:mm")
                      : ""}
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          backgroundColor: "#F27730",
                          color: "#fff",
                          borderRadius: "100px",
                          padding: "2px 10px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          verticalAlign: "middle",
                        }}
                        onClick={() => action(d)}
                      >
                        <p style={{ margin: 0 }}>Editar</p>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const FleetIncidenceTable = (props) => {
  const { header, data, title, handlePageChange, action } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => (
              <th
                key={h?.name}
                style={{
                  padding: "4px 8px 4px 8px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "7px",
                    width: "100%",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr
                  key={d?._id}
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <td>{capitalize(d?.unitType)}</td>
                  <td>
                    {d?.unitData
                      ? `${d?.unitData?.alias} - ${d?.unitData?.plate}`
                      : ""}
                  </td>
                  <td>{capitalize(d?.unitStatus)}</td>
                  <td>
                    {d?.accidentDate
                      ? moment(d?.accidentDate).format("DD-MM-YYYY")
                      : ""}
                  </td>
                  <td>{d?.driver ? capitalize(d?.driver?.contactName) : ""}</td>
                  <td>{capitalize(d?.accidentLocation)}</td>
                  <td>{d?.detail}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          backgroundColor: "#F27730",
                          color: "#fff",
                          borderRadius: "100px",
                          padding: "2px 10px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          verticalAlign: "middle",
                        }}
                        onClick={() => action(d)}
                      >
                        <p style={{ margin: 0 }}>Editar</p>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const AddProvidersTable = (props) => {
  const { header, data, title, removeProvider } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => (
              <th
                key={h?.name}
                style={{
                  padding: "4px 8px 4px 8px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                {h?.name}
              </th>
            ))}
          </tr>
          {data?.length > 0 &&
            !data?.isLoading &&
            data?.map((d, index) => {
              return (
                <tr
                  key={d?._id}
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <td>{capitalize(d?.contactName)}</td>
                  <td>{d?.identificationType + "-" + d?.identification}</td>
                  <td>{d?.phonePrefix + "-" + d?.phoneNumber}</td>
                  <td>{capitalize(d?.state?.name || d?.state)}</td>
                  <td>{d?.type}</td>
                  <td>{d?.isActive}</td>
                  <td>
                    <img
                      style={{ cursor: "pointer" }}
                      src={x}
                      onClick={() => removeProvider(index)}
                      alt="x"
                    />
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const PendingAVFaultsResolvedTable = (props) => {
  const { header, data, title, handlePageChange, action, type } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => (
              <th
                key={h?.name}
                style={{
                  padding: "4px 8px 4px 8px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "7px",
                    width: "100%",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr
                  key={d?._id}
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format("DD-MM-YYYY")
                      : ""}
                  </td>
                  <td>{d?.code ? d?.code : ""}</td>
                  <td>
                    {d?.provider ? capitalize(d?.provider?.contactName) : ""}
                  </td>
                  <td>
                    {d?.solvedFaultStatus
                      ? capitalize(d?.solvedFaultStatus)
                      : ""}
                  </td>

                  <td>
                    {d?.solvedFaultValidatedBy
                      ? capitalize(
                        `${d?.solvedFaultValidatedBy?.firstName} ${d?.solvedFaultValidatedBy?.lastName}`
                      )
                      : ""}
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        height: "100%",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          backgroundColor: "#c42727",
                          color: "#fff",
                          borderRadius: "100px",
                          padding: "2px 10px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          verticalAlign: "middle",
                          display: ![
                            AVFaultServiceResolvedStatus.PENDING,
                            AVFaultServiceResolvedStatus.APPROVED,
                          ].includes(d?.solvedFaultStatus)
                            ? "none"
                            : "flex",
                        }}
                        onClick={() =>
                          action(d?._id, AVFaultServiceResolvedStatus.DENIED)
                        }
                      >
                        <p style={{ margin: 0 }}>Rechazar</p>
                      </div>
                      <div
                        style={{
                          cursor: "pointer",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          backgroundColor: "#F27730",
                          color: "#fff",
                          borderRadius: "100px",
                          padding: "2px 10px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          verticalAlign: "middle",
                          display: ![
                            AVFaultServiceResolvedStatus.PENDING,
                            AVFaultServiceResolvedStatus.DENIED,
                          ].includes(d?.solvedFaultStatus)
                            ? "none"
                            : "flex",
                        }}
                        onClick={() =>
                          action(d?._id, AVFaultServiceResolvedStatus.APPROVED)
                        }
                      >
                        <p style={{ margin: 0 }}>Aprobar</p>
                      </div>
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
        {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      </div>
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(data?.count / data?.limit)}
          variant="outlined"
          shape="rounded"
          page={data?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const DailyReportsTable = (props) => {
  const { header, data, title } = props;

  return (
    <>
      <div className="filter-button-container"></div>
      <div className="title-center-component">
        <h5>{title}</h5>
      </div>
      <div className="table-container">
        <table className="sales-afiliation-table table">
          <tr>
            {header?.map((h) => (
              <th
                key={h?.name}
                style={{
                  padding: "4px 8px 4px 8px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "7px",
                    width: "100%",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  {h?.name}
                  {h?.sortable && (
                    <TableFilter
                      label={h.name}
                      options={h.filterOptions}
                      onSearch={h.filterSearch}
                    />
                  )}
                </div>
              </th>
            ))}
          </tr>
          {data?.data?.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d) => {
              return (
                <tr
                  key={d?._id}
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                    fontSize: "14px",
                  }}
                >
                  <td>
                    {d?.createdAt
                      ? moment(d?.createdAt).format("DD/MM/YYYY hh:mm a")
                      : ""}
                  </td>
                  <td>
                    {d?.startDate
                      ? moment(d?.startDate).format("DD/MM/YYYY hh:mm a")
                      : ""}
                  </td>
                  <td>
                    {d?.endDate
                      ? moment(d?.endDate).format("DD/MM/YYYY hh:mm a")
                      : ""}
                  </td>
                  <td>{d?.user ? capitalize(d?.user) : ""}</td>
                  <td>{d?.reportedErrors}</td>
                  <td>{d?.doneCases?.particular}</td>
                  <td>{d?.activeCases?.scheduled}</td>
                  <td>{d?.activeCases?.active}</td>
                  <td>{d?.doneCases?.done}</td>
                  <td>{d?.doneCases?.doneTowExternal}</td>
                  <td>{d?.doneCases?.doneTowInternal}</td>
                  <td>
                    <CopyToClipboard text={smsText.sendDailyReport(d)}>
                      <button
                        className="copy-sms-text-button"
                        onClick={() => notify("Texto copiado", "success")}
                      >
                        Copiar
                      </button>
                    </CopyToClipboard>
                  </td>
                </tr>
              );
            })}
        </table>
        {data?.data.length <= 0 && !data?.isLoading && (
          <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
        )}
      </div>
    </>
  );
};

export const ComplaintsTable = (props) => {
  const { header, dataTable, handlePageChange, edit, updateStatus } = props;

  const getColorByStatus = (status) => {
    switch (status) {
      case "En espera":
        return "#f14444";
      case "En progreso":
        return "#ffe70b";
      case "Finalizado":
        return "#00BA00";
      default:
        return "#F27730";
    }
  };

  const getLabelByStatus = (status) => {
    switch (status) {
      case "En espera":
        return "En progreso";
      case "En progreso":
        return "Finalizado";
      default:
        return "En Espera";
    }
  };

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr style={{ textAlign: "center" }}>
            {header.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id} style={{ textAlign: "center" }}>
                <td>
                  {d?.complaintDate
                    ? moment(d?.complaintDate).format("DD/MM/YYYY")
                    : ""}
                </td>
                <td>{d?.serviceCode}</td>
                <td>{capitalize(d?.clientName)}</td>
                <td>{capitalize(d?.clientPhone)}</td>
                <td>
                  <span className="tooltip-container tooltip-title">
                    {capitalize(d?.classification)}
                    <span className="tooltip-text">{d?.details}</span>
                  </span>
                </td>
                <td
                  style={{
                    fontSize: "12px",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Badge
                    color={getColorByStatus(d?.status)}
                    label={d?.status}
                  />
                </td>
                <td>
                  <span className="tooltip-container tooltip-title">
                    {capitalize(d?.solution)}
                    <span className="tooltip-text">{d?.solutionDetails}</span>
                  </span>
                </td>
                <td>{d?.solutionAmount}</td>

                <td>{d?.clientSatisfaction}</td>
                <td>{d?.category}</td>
                <td>{d?.plate}</td>
                <td>{d?.socialMedia}</td>
                <td>{d?.leadContributor}</td>
                <td>{d?.contributorName}</td>
                <td>{d?.segmentation}</td>
                <td>
                  <div
                    className="table-buttons-conatiner"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    {!["Finalizado"].includes(d?.status) && (
                      <StatusButton
                        label={getLabelByStatus(d?.status)}
                        color={getColorByStatus(getLabelByStatus(d?.status))}
                        action={() => {
                          if (
                            getLabelByStatus(d?.status) === "Finalizado" &&
                            !d?.solution &&
                            !d?.solutionDetails
                          ) {
                            edit(d);
                          } else {
                            updateStatus(
                              d?._id,
                              getLabelByStatus(d?.status),
                              d
                            );
                          }
                        }}
                      />
                    )}
                    <ActionButton label={"Editar"} action={() => edit(d)} />
                  </div>
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const BatterySalesTable = (props) => {
  const { header, dataTable, handlePageChange } = props;

  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr style={{ textAlign: "center" }}>
            {header.map((h, i) => (
              <th key={i}>{h?.name}</th>
            ))}
          </tr>
          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d) => (
              <tr key={d?._id} style={{ textAlign: "center" }}>
                <td>{d?.enterprise}</td>
                <td>{d?.name}</td>
                <td>{d?.price}</td>
                <td>{d?.stock}</td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const BatteryApplicationTable = (props) => {
  const { header, dataTable, handlePageChange } = props;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <tr style={{ textAlign: "center" }}>
            {header.map((h, i) => (
              <th key={i}>{h?.name}</th>
            ))}
          </tr>
          {dataTable?.data.length > 0 &&
            !dataTable?.isLoading &&
            dataTable?.data.map((d, i) => (
              <tr key={d?._id + i} style={{ textAlign: "center" }}>
                <td>{d?.enterprise}</td>
                <td>{d?.name}</td>
                <td>
                  {d?.allmodels === true ? "Todos" : capitalize(d?.brandName)}
                </td>
                <td>
                  {d?.allmodels === true ? "Todos" : capitalize(d?.modelName)}
                </td>
                <td>
                  {d?.allYears === true
                    ? "Todos"
                    : `${d?.yearMin} - ${d?.yearMax}`}
                </td>
              </tr>
            ))}
        </table>
      </div>
      {dataTable?.isLoading && <TableLoadSpinner show={dataTable?.isLoading} />}
      {dataTable?.data.length <= 0 && !dataTable?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil(dataTable?.count / dataTable?.limit)}
          variant="outlined"
          shape="rounded"
          page={dataTable?.page}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};


export const PotentialClientsTable = (props) => {
  const {
    header,
    data,
    handlePageChange,
    tableRef,
  } = props;

  const resolveDate = (client, type) => {
    if (type === 'Evento') return client?.eventDate ? moment(client.eventDate).format('DD/MM/YYYY') : '-';
    if (type === 'Particular') return client?.serviceDate ? moment(client.serviceDate).format('DD/MM/YYYY') : '-';
    return client?.affiliationDate ? moment(client.affiliationDate).format('DD/MM/YYYY') : '-';
  };

  const type = header?.find((h) => h.name === 'Fecha Evento')
    ? 'Evento'
    : header?.find((h) => h.name === 'Fecha Servicio')
      ? 'Particular'
      : 'Free';

  return (
    <>
      <div className="table-container" ref={tableRef}>
        <table className="table">
          <thead>
            <tr style={{ textAlign: 'center' }}>
              {header?.map((h, i) => (
                <th key={i}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <p style={{ marginRight: '5px' }}>{h?.name}</p>
                    {h?.sortable && h?.filterOptions && (
                      <TableFilter
                        label={h.name}
                        options={h.filterOptions}
                        onSearch={h.filterSearch}
                      />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data?.data) && data.data.length > 0 && !data?.isLoading &&
              data.data.map((client) => {
                const id = client?._id;

                return (
                  <tr key={id} style={{ textAlign: 'center' }}>
                    <td>{capitalize(client?.fullName || '')}</td>
                    <td>{client?.identityDocument || '-'}</td>
                    <td>{client?.phoneNumber || '-'}</td>
                    <td>{resolveDate(client, type)}</td>
                    <td>{client?.city || '-'}</td>
                    <td>{capitalize(client?.salesChannel?.name || '-')}</td>
                    {type === 'Particular' && <td>{capitalize(client?.serviceType || '-')}</td>}
                    <td>{client?.isAffiliated ? 'Sí' : 'No'}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {(!Array.isArray(data?.data) || data.data.length === 0) && !data?.isLoading && (
        <h6 style={{ textAlign: 'center' }}>No hay registros disponibles</h6>
      )}
      <div className="pagination-container">
        <Pagination
          count={Math.ceil((data?.count || 0) / (data?.limit || 50))}
          variant="outlined"
          shape="rounded"
          page={data?.page || 1}
          onChange={handlePageChange}
        />
      </div>
    </>
  );
};

export const TVProvidersCounterTable = (props) => {
  const { header, data, tableRef, } = props;

  const calculateTotal = (data, param) => {
    let total = 0;
    for (let i = 0; i < data?.length; i++) {
      total = total + data[i][param];
    }
    return total;
  };

  return (
    <>
      <div className="table-container particular-counter-table-container">
        <table ref={tableRef} className="table  exportable-table">
          <tr>
            {header?.map((h) => (
              <th key={h?.name}>
                {h?.name}
                {h?.sortable && (
                  <img style={{ cursor: "pointer" }} src={navOptionArrow}></img>
                )}
              </th>
            ))}
          </tr>
          {data?.data.length > 0 &&
            !data?.isLoading &&
            data?.data?.map((d, i) => (
              <tr key={d?._id}>
                <td>
                  {capitalize(d?.firstName) + " " + capitalize(d?.lastName)}
                </td>
                <td>{d?.totalActive}</td>
                <td>{d?.totalDone}</td>
              </tr>
            ))}
          <tr >
            <td>
              <b style={{ padding: "0px" }}>Total</b>
            </td>
            <td>
              <b style={{ padding: "0px" }}>{calculateTotal(data?.data, "totalActive")}</b>
            </td>
            <td>
              <b style={{ padding: "0px" }}>{calculateTotal(data?.data, "totalDone")}</b>
            </td>
          </tr>
        </table>
      </div>
      {data?.isLoading && <TableLoadSpinner show={data?.isLoading} />}
      {data?.data.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
    </>
  );
};

export const OperatorCommissionsTable = ({ data }) => {
  const rows = data?.data || [];

  const sumField = (field) =>
    rows.reduce((acc, row) => acc + (Number(row?.[field]) || 0), 0);

  if (!data?.hasCalculated && !data?.isLoading) {
    return (
      <h6 style={{ textAlign: "center", marginTop: "24px" }}>
        Seleccione mes y año, luego pulse Calcular comisiones
      </h6>
    );
  }

  return (
    <>
      <div className="table-container operator-commissions-table-container">
        <table className="table exportable-table operator-commissions-table">
          <thead>
            <tr>
              <th rowSpan={2}>Operador</th>
              <th colSpan={2} className="operator-commissions-table__group-header">
                Servicios Particulares
              </th>
              <th colSpan={2} className="operator-commissions-table__group-header">
                Venta de Baterías
              </th>
              <th colSpan={2} className="operator-commissions-table__group-header">
                Taller Aliado
              </th>
              <th rowSpan={2} className="operator-commissions-table__total-col">
                Total Pago Comisiones
              </th>
            </tr>
            <tr>
              <th className="operator-commissions-table__sub-header">
                Total servicios
              </th>
              <th className="operator-commissions-table__sub-header">Comisión</th>
              <th className="operator-commissions-table__sub-header">
                Cantidad ventas
              </th>
              <th className="operator-commissions-table__sub-header">Comisión</th>
              <th className="operator-commissions-table__sub-header">
                Cantidad servicios
              </th>
              <th className="operator-commissions-table__sub-header">Comisión</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row?._id}>
                <td>{capitalize(row?.operator)}</td>
                <td>{row?.particularServices}</td>
                <td>{formatCommissionMoney(row?.particularPay)}</td>
                <td>{row?.batteryServices}</td>
                <td>{formatCommissionMoney(row?.batteryPay)}</td>
                <td>{row?.addressVamnServices}</td>
                <td>{formatCommissionMoney(row?.addressVamnPay)}</td>
                <td className="operator-commissions-table__total-col">
                  {formatCommissionMoney(row?.totalPay)}
                </td>
              </tr>
            ))}
          </tbody>
          {rows.length > 0 && (
            <tfoot>
              <tr>
                <td>Total general</td>
                <td>{sumField("particularServices")}</td>
                <td>{formatCommissionMoney(sumField("particularPay"))}</td>
                <td>{sumField("batteryServices")}</td>
                <td>{formatCommissionMoney(sumField("batteryPay"))}</td>
                <td>{sumField("addressVamnServices")}</td>
                <td>{formatCommissionMoney(sumField("addressVamnPay"))}</td>
                <td className="operator-commissions-table__total-col">
                  {formatCommissionMoney(sumField("totalPay"))}
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      {data?.hasCalculated && rows.length <= 0 && !data?.isLoading && (
        <h6 style={{ textAlign: "center" }}>No hay registros disponibles</h6>
      )}
    </>
  );
};